import { render } from "./MissingAccount.vue?vue&type=template&id=67c3dec4"
import script from "./MissingAccount.vue?vue&type=script&lang=js"
export * from "./MissingAccount.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__